import { Attr, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Role from "./Role";

@Model()
class PermissionsRole extends ApplicationRecord {
  static jsonapiType = "permissions_roles";

  @Attr() permission: string;

  @Attr() permissionId: number;

  @HasOne() role: Role;
}

export default PermissionsRole;
